import * as React from 'react';

import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

export const useIOSSwitch = (initState = true) => {
  const [state, setState] = React.useState(initState);

  React.useEffect(() => {
    setState(initState);
  }, [initState]);

  const handleChange = (event) => {
    setState(event.target.checked);
  };

  const Component = ({ _handleChange = () => {} }) => {
    return (
      <IOSSwitch
        value={state}
        checked={state}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          handleChange(e);
          _handleChange(e.target.checked);
        }}
        name="checkedA"
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      />
    );
  };

  return { Component, state, setState };
};
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme, height = 26, thumbWidth = 22, thumbHeight = 22, width = 42 }) => ({
  width: width,
  height: height,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5EC4AC',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: thumbWidth,
    height: thumbHeight,
  },
  '& .MuiSwitch-track': {
    borderRadius: height / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default IOSSwitch;
